import Vue from "vue";
import App from "./App.vue";
import router from "./routes/index";
import * as firebase from "firebase";
import store from "./store";
Vue.config.productionTip = false;

const configOptions = {
  apiKey: "AIzaSyCURbffvef8mKQ-IsOZUCFB9oZHF_TLfIw",
  authDomain: "baoopilotapp.firebaseapp.com",
  databaseURL: "https://baoopilotapp.firebaseio.com",
  projectId: "baoopilotapp",
  storageBucket: "baoopilotapp.appspot.com",
  messagingSenderId: "780752248711",
  appId: "1:780752248711:web:31f7b26d9ffab47966fd22",
  measurementId: "G-QPT7WDJVPV"
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

import Notifications from 'vue-notification'
import { BootstrapVue } from 'bootstrap-vue'

import '../scss/custom.scss'


Vue.use(Notifications);
Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

